import React from "react";

/**
 * Shared section collapse/expand control — text label, not an icon.
 *
 * 2026-09-12 (chat, re: OI Autopilot screenshot — "Toggle --- let's make it
 * consistent entire app. I prefer Show\Hide") — previously this rendered a
 * lone rotating chevron ("collapsed" looked like a bare ">" arrow), while
 * several components had separately hand-rolled their OWN inline
 * "Show"/"Hide" text toggle for the same job (e.g. OIAutopilot.jsx's Paper
 * Trade History row, CandleBreakout.jsx, VWAPOI.jsx, SniperTrades.jsx,
 * JournalPage.jsx) — two different visual languages for the identical
 * action. Standardizing on text here, since this component is shared by all
 * 15 section-header toggles across the app (BearishPESetup, VWAPBounce,
 * CandleBreakout, OIAutopilot, ORB, GapAndGo, SetupEGammaSpike, VWAPOI,
 * SniperTrades, OISuggestions, MarketSentiment, Watchlist,
 * LiveOrderAuditLog, LiveOrdersHistory), changing it here reskins every one
 * of them with no per-file edits — same "one shared component" leverage as
 * the .theme-terminal rollout. Deliberately NOT touching the separate
 * per-row expand/collapse chevrons used inside trade tables (e.g.
 * BearishPESetup's TradeRow) — those are inline row disclosures, a
 * different pattern from this section-level toggle, and weren't what the
 * screenshot was pointing at.
 */
export const CollapseToggle = ({ collapsed, onToggle, testId }) => (
  <button
    data-testid={testId}
    onClick={onToggle}
    aria-label={collapsed ? "Show section" : "Hide section"}
    className="border-grid surface px-3 py-1.5 text-[10px] uppercase tracking-wider font-mono-data hover:bg-white/5 transition-colors"
    style={{ color: "var(--text-muted)" }}
  >
    {collapsed ? "Show" : "Hide"}
  </button>
);
